import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Page, TextStyleBody } from '@style/Shared';
import Menu from '@client/modules/Menu/Menu';
import GotoElement from '@client/core/utils/GotoElement';
import { Breakpoints, Colors, presetColors } from '@client/style/Variables';
import MyPageFavourites from '@client/modules/MyPage/MyPageFavourites';
import SimpleFooter from '@client/modules/Footers/SimpleFooter';
import MagicModuleSwitcher from '@client/modules/MagicModuleSwitcher';
import { TextStyle } from '@client/style/TextStyles';
import { useAuthenticatedStatus, useAuthenticatedUser } from '@client/utils/AuthStore';
import MyPageRegistration from '@client/modules/MyPage/MyPageRegistration';
import { LoginLogoutButton } from '@client/modules/Auth/LoginLogoutButton';
import { context } from '@client/context';
import PageHandler from '@client/core/PageSwitch/PageHandler';
import Functions from '@client/style/Functions';

const StyledPage = styled(Page)<{ $bg?: string; $fg?: string }>`
	background-color: ${props => props.$bg || presetColors.nude};
	color: ${props => props.$fg || Colors.darkText};
	min-height: 100vh;
`;

const Title = styled.h1`
	width: 100%;
	text-align: center;
	margin-top: 2.5em;
	${TextStyle.family('title')}
	${TextStyle.weight('bold')}
	${TextStyle.size('p2', 'h2')}

	${Functions.breakpoint(Breakpoints.mobile)} {
		margin-top: 1em;
	}
`;

const NotAuthenticated = styled.h2`
	${TextStyleBody}
	padding-top: 30px;
	padding-bottom: 30px;
	text-align: center;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 20px;
`;

export default function MyPage(props: {
	content?: any;
	backgroundColorLink?: { color: string; contrastColor: string };
}) {
	const user = useAuthenticatedUser();
	// const status = useAuthenticatedStatus();

	// useEffect(() => {
	// 	const prev = PageHandler.getInstance().previousLink;
	// 	if (!prev && status === 'signed-out') context.auth.signIn(true);
	// }, [status]);

	return (
		<StyledPage $bg={props.backgroundColorLink?.color} $fg={props.backgroundColorLink?.color}>
			<Menu
				onLogoClick={() => GotoElement.Instance.scrollToElementWithId(`module_${props.content.startId}`)}
				specificColor={Colors.footerDarkBackground}
			/>

			<Title>{props.content.title}</Title>

			{user ? (
				<>
					<MyPageRegistration />
					<MyPageFavourites artists={props.content._artists} />
				</>
			) : (
				<NotAuthenticated>
					<p>Log ind for at se din side</p>
					<LoginLogoutButton />
				</NotAuthenticated>
			)}

			<MagicModuleSwitcher modules={props.content ? props.content.modules : []} />

			<SimpleFooter />
		</StyledPage>
	);
}
